import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { useCheckout } from 'checkout/context';
import { CheckoutVariants } from 'src/constants/checkout-variants';

type Props = {
  brandName?: string;
  href: string;
  isMobileEcommApp: boolean;
  productString: string;
};

export function ProductDetails(props: Props): JSX.Element {
  const { brandName, href, isMobileEcommApp, productString } = props;
  const { variant } = useCheckout();

  const details = (
    <>
      {!_.isEmpty(brandName) && <BrandName>{brandName}</BrandName>}
      <ProductName>{productString}</ProductName>
    </>
  );

  return (
    <Container>
      {variant === CheckoutVariants.isolatedCheckout || isMobileEcommApp ? (
        details
      ) : (
        <a href={href} data-testid='checkout-product-summary-link'>
          {details}
        </a>
      )}
    </Container>
  );
}

const Container = styled.div`
  flex: 1 0 0%;
  min-width: 0;
  padding-right: 12px;
`;

const ProductName = styled.div`
  color: #5d666d;
  font-size: 13px;
  line-height: 1.325;
  min-width: 0;
  overflow-wrap: break-word;
`;

const BrandName = styled.div`
  color: #949ea8;
  font-size: 11px;
  font-weight: bold;
  margin: 2px 0 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;
